export const APP_WEB = import.meta.env.VITE_APP_WEB === "true";//分享的
export const APP_WEB_WWW = import.meta.env.VITE_APP_WEB_WWW === 'true';//离线画布的
export const APP_WEB_SITE = import.meta.env.VITE_APP_WEB_SITE === 'true';//web app的需要有后台服务

export const DEBUG = import.meta.env.DEV;

/**
 * web的项目
 */
export const isWeb = ()=>{
    return APP_WEB || APP_WEB_WWW || APP_WEB_SITE;
}

/**
 * web的项目
 */
export const isOfflineWeb = ()=>{
    return APP_WEB_WWW;
}

/**
 * 是否保存到服务端---使用的webapp
 */
export const isWebApp = ()=>{
    if (APP_WEB_SITE){
        return true;
    }
    return false;
}
